module.exports = __webpack_public_path__ + "img/full3-min.d3f5819d.png";